import React from 'react';
import { useAuth } from '../contexts/AuthContext';

// User profile component for displaying user info
// On mobile: clickable icon that opens dropdown (handled by parent)
// On desktop: just displays icon
const UserProfile = ({ onClick }) => {
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div className="user-profile-icon-only" onClick={onClick}>
      <img 
        src={user.picture} 
        alt={user.name || user.email}
        className="user-avatar-icon"
        title={user.name || user.email}
      />
    </div>
  );
};

export default UserProfile;
